<template>
  <div class="container mycard_vision_new">
    <div class="head">
      <div class="head__fixed">
        <div class="head__fixed__box">
          <div class="header__fixed__left"><a href="javascript:history.go(-1)" class="back"></a></div>
          <div class="header__fixed__center">
            <h1>企业会员</h1>
            <!-- <div :class="[{'bb_bmHeadF':cardStatus==2},'bb_bmHead']" @click="switchCardStatus(1)">
              斐燃会员
              <div class="bb_bmHead_line" v-show="cardStatus==1"></div>
            </div>
            <div :class="[{'bb_bmHeadF':cardStatus==1},'bb_bmHead']" @click="switchCardStatus(2)">
              企业会员
              <div class="bb_bmHead_line" v-show="cardStatus==2"></div>
            </div> -->
          </div>
          <div class="header__fixed__right"></div>
        </div>
      </div>
    </div>
    <div v-show="loaded">
      <div class="m_container_hei" v-if="mycard.length>0">
        <div class="visiontotaltop"></div>
        <div class="m_container ">
          <div class="hd_img_list morecard ">
            <ul>
              <li v-for="item in mycard" @click="cardeail(item)">
                <!-- <img class="mycard_hei" v-if="item.thumb==null||item.thumb==''" src="../../assets/images/base/fixedCard.png" /> -->
                <img class="mycard_hei" :src="item.thumb" />
                <div class="hyk_pos">
                  <div class="hyk_nrs">
                    <div class="pox_mr_ico" v-for="(itemCon,index) in cards_gift_record" v-if="itemCon.user_cards_id==item.id">
                      <img src="../../assets/images/base/mine_card_gift2.png">
                    </div>
                    <div class="hyk_pos_bb">
                      <p>{{item.msg_3}}</p>
                    </div>
                    <div class="hyk_pos_c">
                      <p>{{item.msg_1}}</p>
                      <p>{{item.msg_2}}</p>
                    </div>
                    <div class="hyk_pos_d">
                      <p>{{item.end_date}}到期</p>
                      <p>NO. {{item.cards_no.slice(-10)}}</p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="visiontotaltop"></div>
      </div>
      <div v-else>
        <img class="usernoncardstatus_img" src="../../assets/images/base/gwc.png" />
        <div class="usernoncardstatus">开通斐燃会员即可享受预约服务哦～</div>
        <div class="usernoncardstatusbtn" @click="tores()">去开通</div>
      </div>
    </div>
    <img v-show="mycard.length>0" @click="FLToActive()" class="fl_carmichael" src="../../assets/images/FLVersion/fl_card_code.png" />
  </div>
</template>

<script>
  export default {
    data() {
      return {
        loaded: false,
        mycard3: [],
        mycard124: [],
        mycard: [],
        cards_gift_record: [],
        cardStatus: 2
      }
    },
    created() { },
    mounted() {

    },
    activated() {

      this.getmork()
      // 判断是否需要滚动到顶部（welcome页面直接进入此页面，需要执行此处）
      if(sessionStorage.getItem('index_scroll_top')=='yes'){
        sessionStorage.removeItem('index_scroll_top')
        window.scrollTo(0, 0)
      }
    },
    methods: {
      switchCardStatus(item) {
        this.cardStatus = item
        this.fliterCard()
      },
      fliterCard() {
        window.scrollTo(0, 0)
        if (this.cardStatus == 1) { //斐燃会员
          this.mycard = this.mycard3
        } else {
          this.mycard = this.mycard124
        }
      },
      tores() {
        this.$router.push({
          name: 'activate_single'
        })
      },
      cardeail(item) {;
        this.$router.push({
          name: 'myCardDetail',
          params: {
            id: item.id
          }
        })
      },
      getmork() {
        var $this = this
        $this.loaded = false
        if($this.$store.state.array_mycard.length==0){
          let param = {
            token: localStorage.getItem("token"),
          }
          // return
          $this.mycard = []
          $this.mycard3 = []
          $this.mycard124 = []
          //

          // $this.$store.commit('setStadiums',result.data.stadiums)
          // this.$store.state.list_stadiums

          $this.$loading('正在加载')
          var qs = require('qs');
          let url = this.api.userApi.flUserCardsList
          this.axios.post(url, qs.stringify(param), )
          .then((result) => {
            // console.log(result)

            if (result.data) {

              // // console.log($this.$store.state.list_myCards)
              // $this.$store.commit('setMyCards',result.data)
              // // console.log($this.$store.state.list_myCards)
              $this.$store.commit('updataMycard',result.data)
              for (var i = 0; i < result.data.length; i++) {
                if (result.data[i].type == 3) {
                  $this.mycard3.push(result.data[i])
                } else {
                  $this.mycard124.push(result.data[i])
                }
              }

              // $this.getgiftrecord()
              $this.fliterCard()
              setTimeout(function(){
                $this.$loading.close()
                $this.loaded = true
              },500)
            } else {
              $this.$loading.close()
              // $this.$toast(result.msg)
              $this.loaded = true
            }
          }).catch((error) => {
            // console.warn(error)
            $this.$loading.close()
            // $this.$toast('error');
            $this.loaded = true
          })
        }else{
          var curlist=$this.$store.state.array_mycard
          $this.mycard = []
          $this.mycard3 = []
          $this.mycard124 = []

          for (var i = 0; i < curlist.length; i++) {
            if (curlist[i].type == 3) {
              $this.mycard3.push(curlist[i])
            } else {
              $this.mycard124.push(curlist[i])
            }
          }

          // $this.getgiftrecord()
          // $this.$loading.close()
          $this.fliterCard()
          setTimeout(function(){

            $this.loaded = true
          },500)
        }








      },
      getgiftrecord() {
        var $this = this
        let param = {
          token: localStorage.getItem("token")
        }
        var qs = require('qs');
        let url = this.api.userApi.getUserCards
        this.axios.post(url, qs.stringify(param), )
          .then((result) => {
            // // console.log(result)
            if (result.code == 0) {
              $this.$loading.close()
              $this.cards_gift_record = result.data.logs
            } else {
              $this.$loading.close()
              $this.$toast(result.msg)
            }
          }).catch((error) => {
            // console.warn(error)
            $this.$loading.close()
            // $this.$toast('error');
          })
      },
      FLToActive(){
        this.$router.push({
          name: 'activate_single',
        })
      }
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;

  .header__fixed__center {
    .bb_bmHead {
      width: 50%;
      float: left;
      height: 90*@vm_base;
      font-size: 28*@vm_base;
      font-weight: 600;
      color: rgba(68, 64, 84, 1);
      line-height: 90*@vm_base;
      text-align: center;
      position: relative;

      .bb_bmHead_line {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 39*@vm_base;
        height: 10*@vm_base;
        background: rgba(68, 64, 84, 1);
        border-radius: 25%;
        margin-left: calc(50% - 19.5*@vm_base);
      }
    }

    .bb_bmHeadF {
      font-weight: 400;
      color: rgba(180, 179, 187, 1);
    }
  }

  .hyk_pos_bb {
    left: 40*@vm_base;
  }

  .hyk_pos_c {
    left: 40*@vm_base;
    white-space: nowrap;
  }

  .m_container_hei {
    height: calc(100vh - 100*@vm_base);
    overflow: hidden;
    overflow-y: auto;
  }

  .visiontotaltop {
    height: 22*@vm_base;
  }

  .m_container {
    padding: 0px;
    width: 100%;
    height: auto;
    overflow: hidden;
    margin: 0 auto;
  }

  .hd_img_list {
    padding: 0px 20*@vm_base;
  }

  .hd_img_list ul li {
    margin-top: 36*@vm_base;
  }

  .hd_img_list ul li img {
    width: 100%;
    height: auto;
  }

  .morecard li {
    position: relative;
  }

  .morecard li img {
    border-radius: 12*@vm_base;
  }

  .mycard_vision_new {
    width: 100%;
    height: 100vh;
    background: #FFFFFF;

    .mycard_hei {
      height: 386*@vm_base;
    }
  }

  .hyk_pos {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
  }

  .hyk_pos_a {
    top: 50*@vm_base;
    left: 32*@vm_base;
    font-size: 42*@vm_base;
    color: rgba(255, 255, 255, 1);
    letter-spacing: 1*@vm_base;
  }

  .hyk_pos_b {
    top: 70*@vm_base;
    right: 32*@vm_base;
    font-size: 28*@vm_base;
    color: rgba(255, 255, 255, 1);
  }

  .hyk_pos_bb {
    left: 32*@vm_base;
    bottom: 140*@vm_base;
    font-size: 28*@vm_base;
    line-height: 34*@vm_base;
    color: rgba(255, 255, 255, 1);
    width: 330*@vm_base;
  }

  .hyk_pos_c {
    left: 32*@vm_base;
    bottom: 44*@vm_base;
    font-size: 24*@vm_base;
    line-height: 34*@vm_base;
    color: rgba(255, 255, 255, 0.5);
    width: 330*@vm_base;
  }

  .hyk_pos_d p {
    margin-top: 8*@vm_base;
    color: rgba(255, 255, 255, 0.5);
  }

  .hyk_pos_c p {
    margin-top: 8*@vm_base;
    color: rgba(255, 255, 255, 0.5);
  }

  .hyk_pos_d {
    right: 32*@vm_base;
    bottom: 44*@vm_base;
    font-size: 24*@vm_base;
    color: rgba(255, 255, 255, 0.5);
    text-align: right;
    font-family: PingFangSC-Regular, PingFang SC !important;
  }

  .hyk_nrs div {
    position: absolute;
  }

  .pox_mr_ico {
    position: absolute;
    top: 152*@vm_base  !important;
    right: -4*@vm_base;
  }

  .pox_mr_ico img {
    width: 74*@vm_base  !important;
    height: auto;
  }

  .usernoncardstatus_img {
    width: 50%;
    margin-left: 25%;
    margin-top: 32*@vm_base;
    margin-bottom: 54*@vm_base;
    margin-top: 97*@vm_base;
  }

  .usernoncardstatus {
    width: 100%;
    text-align: center;
    color: #444054;
    font-size: 28*@vm_base;
  }

  .usernoncardstatusbtn {
    width: 300*@vm_base;
    height: 80*@vm_base;
    line-height: 80*@vm_base;
    text-align: center;
    color: #FFFFFF;
    background: #444054;
    font-size: 32*@vm_base;

    border-radius: 12*@vm_base;
    margin: 0 auto;
    margin-top: 44*@vm_base;
  }

  .fl_carmichael{
    position: fixed;
    bottom: 0;
    right: 0;
    width: 100*@vm_base;
    margin: 0 20*@vm_base 160*@vm_base 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/myCard/myCard.vue